import Button from "./Button.jsx"
import ConfirmButtonImage from '../../img/chevron-right.svg';

import SCHOOLS_DETAILS from '../constants/SchoolsDetails'
import { Link } from "react-router-dom";

import "../../css/Table.css";

const Table = ({ pattern, onRowSelect, isSearched }) =>
  <div className="table">
    <div className="table-header">
        <span className="school-name">School</span>
        <span className="school-rollnumber">Roll Number</span>
        <span className="school-sethours">SET Hours</span>
        <span className="confirm-button"></span>
    </div>
    {SCHOOLS_DETAILS.filter(isSearched(pattern)).map(item =>
      <Link key={item.rollNumber} className="table-row" onClick={() => onRowSelect(item.i)} to={`/targethours/${item.rollNumber}`}>
      {/* <Link key={item.rollNumber} className="table-row" onClick={() => onRowSelect(item.i)} to={`/schoolmatcher/${item.rollNumber}`}> */}
        <span className="school-name">{item.schoolName}</span>
        <span className="school-rollnumber">{item.rollNumber}</span>
        <span className="school-sethours">{item.SETHours}</span>
        <span className="confirm-button">
          <Button 
            className="button-inline"
          >
            <img src={ConfirmButtonImage} alt="chevron-right"/>
          </Button>
        </span>
      </Link>
    )}
  </div>

export default Table;